<table
  mat-table
  [dataSource]="dataSource"
  matSort
  [matSortDisabled]="sortDisabled"
  class="w-100 mat-small-table table-with-input table-hover"
>
  @for (col of columns; track col) {
    <ng-container matColumnDef="{{ col.id }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [hidden]="inputDisabled && col.canHide == true"
        [class.text-end]="
          col.type == 2 || col.type == 3 || col.type == 6 || col.textRight
        "
      >
        <span [class.percent-header]="col.type == 2" [class.bold]="col.bold">{{
          col.label
        }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        [hidden]="inputDisabled && col.canHide == true"
        [class.text-end]="
          col.type == 2 || col.type == 3 || col.type == 6 || col.textRight
        "
        [class.pe-4]="
          (col.type == 2 || col.type == 3 || col.type == 6 || col.textRight) &&
          !disableRightPadding
        "
      >
        @switch (col.type) {
          @case (1) {
            <div>{{ element[col.id] }}</div>
          }
          @case (2) {
            <div>
              <span class="number-col" [class.bold]="col.bold">{{
                element[col.id] !== null && element[col.id] !== 0
                  ? ((element[col.id] * 100).toFixed(2) | number: "1.2-2") + "%"
                  : "-"
              }}</span>
            </div>
          }
          @case (3) {
            <div>
              <span class="number-col" [class.bold]="col.bold"
                >{{ element[col.id] | number: "1.0-2" }}
                @if (col.suffix) {
                  <span>{{ col.suffix }}</span>
                }
              </span>
            </div>
          }
          @case (4) {
            <div>
              <mat-form-field
                class="max-100 table-input-suffix"
                appearance="outline"
              >
                <input
                  matInput
                  type="number"
                  [(ngModel)]="element[col.id]"
                  step="0.1"
                  [disabled]="inputDisabled"
                  (focus)="onInputFocus(element, col.id)"
                  (ngModelChange)="onInputChange()"
                />
                @if (col.suffix) {
                  <span matSuffix>{{ col.suffix }}</span>
                }
              </mat-form-field>
            </div>
          }
          @case (5) {
            <div>
              <span
                class="underline-on-hover ms-2 text-truncate"
                (click)="onCompanyInfoClick(element)"
                >{{ element[col.id] }}</span
              >
            </div>
          }
          @case (6) {
            <div>
              <span class="number-col" [class.bold]="col.bold">
                {{
                  isString(element[col.id])
                    ? element[col.id]
                    : (element[col.id] | number: "1.0-2")
                }}
                @if (col.suffix) {
                  <span>{{ col.suffix }}</span>
                }
              </span>
            </div>
          }
        }
      </td>
      @if (footer) {
        <td
          mat-footer-cell
          [class.text-end]="col.type == 2 || col.type == 3"
          [class.pe-4]="
            (col.type == 2 || col.type == 3) && !disableRightPadding
          "
          *matFooterCellDef
        >
          <span
            class="bold"
            [class.number-col]="col.type == 2 || col.type == 3"
            >{{ footer[col.id] }}</span
          >
        </td>
      }
    </ng-container>
  }
  <tr mat-header-row *matHeaderRowDef="columnLabels"></tr>
  <tr mat-row *matRowDef="let row; columns: columnLabels"></tr>
  @if (footer) {
    <tr mat-footer-row *matFooterRowDef="columnLabels"></tr>
  }
  >
</table>
<mat-paginator
  [hidden]="!needPaginator"
  [pageSizeOptions]="[10, 20, 30]"
  showFirstLastButtons
></mat-paginator>
